import { render, staticRenderFns } from "./UserSubMenu.vue?vue&type=template&id=1dc73485&"
import script from "./UserSubMenu.vue?vue&type=script&lang=js&"
export * from "./UserSubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports